import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { PAGE_HOME } from '@poplar/constants/routes';
import { URL_YO_PRIVACY_POLICY, URL_YO_COOKIE_POLICY, URL_YO_TERMS_OF_SERVICE, URL_YO_SPECIFIED_COMMERCIAL_TRANSACTIONS } from '@poplar/constants/urls';
import { YohanaLogo } from '@yoweb/ui/components/Icon/YohanaLogo';
import { Interactive, Text } from '@yoweb/ui/components/typography';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { media } from '@yoweb/ui/styles/utils';
import { getColor, getRadii, getSpace } from '@yoweb/ui/styles/utils/theme';
import { URL_GOOGLE_PRIVACY_POLICY, URL_GOOGLE_TERMS } from '@yoweb/utils/constants/urls';
import { Social } from '@yoweb/ui/components/Social';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { Box } from '@yoweb/ui/components/Box';
import RegionSelector from '@yoweb/ui/components/RegionSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CopyrightLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(Interactive, _objectSpread({
    as: "a",
    weight: "semibold",
    variant: "inverseMuted",
    size: "sm",
    textDecoration: "underline",
    target: "_blank",
    ref: ref
  }, props));
});
CopyrightLink.displayName = 'CopyrightLink';
/**
 * A footer that goes at the bottom of every page.
 */

var Footer = function Footer() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useExternalConfig = useExternalConfig(),
      baseStoreUrl = _useExternalConfig.baseStoreUrl,
      baseUsUrl = _useExternalConfig.baseUsUrl,
      baseJpUrl = _useExternalConfig.baseJpUrl;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';
  var year = new Date().getFullYear();
  return /*#__PURE__*/_jsxs(Box, {
    position: "relative",
    children: [/*#__PURE__*/_jsx(Background, {}), /*#__PURE__*/_jsx(StyledFooter, {
      "data-testid": "footer",
      children: /*#__PURE__*/_jsx(Box, {
        mx: "medium2",
        children: /*#__PURE__*/_jsxs(Box, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(Link, {
            href: PAGE_HOME,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/_jsx(LogoWrap, {
              href: PAGE_HOME,
              "data-testid": "footer-logo-wrap",
              children: /*#__PURE__*/_jsx(YohanaLogo, {
                width: 100,
                height: 32
              })
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: {
              _: 'normal3',
              md: 'medium1',
              lg: 'medium3'
            },
            children: /*#__PURE__*/_jsx(Social, {})
          }), /*#__PURE__*/_jsxs(CopyrightContainer, {
            "data-testid": "copyright-links-container",
            children: [/*#__PURE__*/_jsxs(Box, {
              display: "flex",
              gap: {
                _: 'small3',
                md: 'normal1'
              },
              flexDirection: {
                _: 'column',
                md: 'row'
              },
              alignItems: "start",
              children: [/*#__PURE__*/_jsx(Link, {
                href: URL_YO_TERMS_OF_SERVICE(baseStoreUrl),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(CopyrightLink, {
                  "data-testid": "tos-link",
                  children: t('footer.terms-of-service')
                })
              }), /*#__PURE__*/_jsx(Link, {
                href: URL_YO_PRIVACY_POLICY(baseStoreUrl),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(CopyrightLink, {
                  "data-testid": "privacy-policy-link",
                  children: t('footer.privacy-policy')
                })
              }), /*#__PURE__*/_jsx(Link, {
                href: URL_YO_COOKIE_POLICY(baseStoreUrl),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(CopyrightLink, {
                  "data-testid": "cookie-policy-link",
                  children: t('footer.cookie-policy')
                })
              }), isJapanLocale ? /*#__PURE__*/_jsx(Link, {
                href: URL_YO_SPECIFIED_COMMERCIAL_TRANSACTIONS(baseStoreUrl),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(CopyrightLink, {
                  "data-testid": "specified-commercial-transactions-link",
                  children: t('footer.specified-commercial-transactions')
                })
              }) : null]
            }), /*#__PURE__*/_jsx(Box, {
              ml: {
                _: 'none',
                md: 'normal1'
              },
              children: /*#__PURE__*/_jsx(Text, {
                variant: "inverseMuted",
                size: "sm",
                "data-testid": "copyright-text",
                children: /*#__PURE__*/_jsx(Trans, {
                  t: t,
                  i18nKey: "footer.copyright-line",
                  values: {
                    year: year
                  }
                })
              })
            }), /*#__PURE__*/_jsx(Box, {
              display: "flex",
              justifyContent: {
                _: 'start',
                lg: 'end'
              },
              pr: {
                _: 'none',
                lg: 'normal2'
              },
              children: /*#__PURE__*/_jsx(RegionSelector, {
                baseUsUrl: baseUsUrl,
                baseJpUrl: baseJpUrl
              })
            })]
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            children: /*#__PURE__*/_jsx(Text, {
              size: "xs",
              weight: "bold",
              variant: "muted2",
              children: /*#__PURE__*/_jsx(Trans, {
                t: t,
                i18nKey: "footer.google-policy-line",
                components: [/*#__PURE__*/_jsx(Text, {
                  as: "a",
                  variant: "muted2",
                  href: URL_GOOGLE_TERMS,
                  rel: "noopener noreferrer",
                  size: "xs",
                  textDecoration: "underline",
                  target: "_blank",
                  "data-testid": "google-tos-link"
                }, 1), /*#__PURE__*/_jsx(Text, {
                  as: "a",
                  variant: "muted2",
                  href: URL_GOOGLE_PRIVACY_POLICY,
                  rel: "noopener noreferrer",
                  size: "xs",
                  textDecoration: "underline",
                  target: "_blank",
                  "data-testid": "google-privacy-policy-link"
                }, 0)]
              })
            })
          })]
        })
      })
    })]
  });
};

var Background = styled.div.withConfig({
  componentId: "sc-6t8947-0"
})(["background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";height:100%;left:0;position:absolute;top:0;width:100%;"], getColor('base900'), getRadii('large'), getRadii('large'));
var StyledFooter = styled.footer.withConfig({
  componentId: "sc-6t8947-1"
})(["padding:", " 0;", ""], getSpace('medium3'), media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", " 0;\n  "])), getSpace('large2')));
var LogoWrap = styled.a.withConfig({
  componentId: "sc-6t8947-2"
})(["display:flex;color:", ";"], getColor('base000'));
var CopyrightContainer = styled.div.withConfig({
  componentId: "sc-6t8947-3"
})(["align-items:baseline;display:grid;grid-row-gap:", ";padding-top:", ";grid-template-columns:1fr;", " ", ""], getSpace('normal1'), getSpace('normal1'), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-template-columns: max-content max-content;\n\n    a {\n      grid-row: 1;\n    }\n  "]))), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-template-columns: max-content max-content 1fr;\n    padding-top: ", ";  \n  "])), getSpace('normal2')));
export { Footer };
export default Footer;